export class StopAreaInsertFailed extends Error {}
